module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm-title"
  }, [_vm._v("ILLUSTRATIONS")]), _vm._v(" "), _c('p', {
    staticClass: "num_list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Plates#img1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "num_list1"
  }, [_vm._v("1")]), _vm._v(" Udet poses in front of a LVG biplane")])]), _vm._v(" "), _c('p', {
    staticClass: "num_list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Plates#img2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "num_list1"
  }, [_vm._v("2")]), _vm._v(" Udet in 1916, aged nineteen")])]), _vm._v(" "), _c('p', {
    staticClass: "num_list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Plates#img3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "num_list1"
  }, [_vm._v("3")]), _vm._v(" In love in 1918: the 22-year-old Lieutenant Udet on vacation with his childhood sweetheart Eleanor ‘Lo’ Zink")])]), _vm._v(" "), _c('p', {
    staticClass: "num_list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Plates#img4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "num_list1"
  }, [_vm._v("4")]), _vm._v(" Ernst Udet with fellow First World War ace Bruno Loerzer")])]), _vm._v(" "), _c('p', {
    staticClass: "num_list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Plates#img5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "num_list1"
  }, [_vm._v("5")]), _vm._v(" Udet’s celebrated aerobatic sports plane and trainer aircraft the Udet U 12 Flamingo")])]), _vm._v(" "), _c('p', {
    staticClass: "num_list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Plates#img6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "num_list1"
  }, [_vm._v("6")]), _vm._v(" Udet performs while admiring young fans look on in amazement")])]), _vm._v(" "), _c('p', {
    staticClass: "num_list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Plates#img7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "num_list1"
  }, [_vm._v("7")]), _vm._v(" Udet and the Allied ‘Ace of Aces’, Frenchman René Fonck. Opponents in the First World War they met as friends in Berlin, 1928")])]), _vm._v(" "), _c('p', {
    staticClass: "num_list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Plates#img8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "num_list1"
  }, [_vm._v("8")]), _vm._v(" Wing Commander Udet wearing the uniform of the DLV (German Air Sports Association) and with the World War One Pour le Mérite medal around his neck, circa 1933–36")])]), _vm._v(" "), _c('p', {
    staticClass: "num_list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Plates#img9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "num_list1"
  }, [_vm._v("9")]), _vm._v(" Cartoon drawn by Udet as a souvenir of an aerial diving demonstration he gave in his American Curtiss Hawk biplane, 12 June 1934")])]), _vm._v(" "), _c('p', {
    staticClass: "num_list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Plates#img10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "num_list1"
  }, [_vm._v("10")]), _vm._v(" Aerial acrobatics in the Curtiss Hawk")])]), _vm._v(" "), _c('p', {
    staticClass: "num_list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Plates#img11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "num_list1"
  }, [_vm._v("11")]), _vm._v(" Udet examining plans with his former First World War commander Hermann Göring")])]), _vm._v(" "), _c('p', {
    staticClass: "num_list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Plates#img12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "num_list1"
  }, [_vm._v("12")]), _vm._v(" Udet on his 45th birthday, in 1941, just a few months before his death")])]), _vm._v(" "), _c('p', {
    staticClass: "num_list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Plates#img13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "num_list1"
  }, [_vm._v("13")]), _vm._v(" Udet’s grave in the Invalid’s Cemetery in Berlin")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80126e6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Illustrations.vue
// module id = 72
// module chunks = 0